<template>
    <div>
        <Legal />
        <Footer />
    </div>
</template>
